export { BottomDrawer } from './BottomDrawer';
export { DrawerHeader, DrawerHeaderSecondary } from './DrawerHeader';
export { DrawerContent, DrawerContentSecondary } from './DrawerContent';
export { DrawerBody } from './DrawerBody';
export { DrawerFooter } from './DrawerFooter';
export const primaryDrawerWidth = 600;
export const secondaryDrawerWidth = 534;
